import { useWellKnown } from "../hooks/useWellKnown";
import "../styles/components/signup.css";

export default function Signup() {
  const { data } = useWellKnown();

  return (
    <section className="call-to-action-banner">
      <div className="call-to-action-banner__inner">
        <div className="call-to-action-banner__text">
          <h2 className="call-to-action-banner__title">Claim your free listing</h2>
          <p className="call-to-action-banner__description">
            If you haven't claimed your free listing yet to appear in the above listing, why not register your business
            today! Registration is simple and easy with AI features to help complete your Business Listing Information.
          </p>
        </div>
        <div className="call-to-action-banner__actions">
          <div className="call-to-action-banner__badge">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            Free to list
          </div>
          {data?.register_form && (
            <a
              href={data.register_form}
              target="_blank"
              rel="noopener noreferrer"
              className="call-to-action-banner__button call-to-action-banner__button--primary"
            >
              Register
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
